import { useIntl } from "react-intl";
import { TextField } from "./text-field";

export type EmailFieldProps = {
	label: string;
	required?: boolean;
};

export function EmailField({ label, required }: EmailFieldProps) {
	const intl = useIntl();
	return (
		<TextField
			label={label}
			type="email"
			placeholder={intl.formatMessage({
				id: "form.field.email.placeholder",
				defaultMessage: "Enter email",
			})}
			required={required}
		/>
	);
}
